import moment from 'moment';

/* */
export const isPrincipal = (membership) => membership.members && membership.members
  .find((m) => m.lines && m.lines.find((l) => (l.type === '1')));

/* */
export const calculateSchedule = (totalAmount, months, startAt) => {
  const startDate = moment(startAt);
  const perMonth = Math.floor((totalAmount / 100) / months) * 100;
  const last = totalAmount - ((months - 1) * perMonth);

  const schedule = [];
  for (let i = 0; i < months; i += 1) {
    const amount = (i === (months - 1)) ? last : perMonth;
    schedule.push({
      amount,
      date: startDate.format('YYYY-MM-DD'),
    });
    startDate.add(1, 'M');
  }

  return schedule;
};
